<template>
  <ValidationProvider
    v-slot="{ errors, valid, validated }"
    :name="name"
    :rules="checkboxRules"
    slim
  >
    <div>
      <b-form-checkbox
        :id="id"
        v-model="model"
        :class="{'is-invalid': !valid && validated}"
        :name="name"
        v-bind="$attrs"
        :size="size"
        stacked
        v-on="listeners"
      >
        <slot name="label">
          {{ $attrs.label }}
          <span
            v-if="$attrs.required !== undefined && $attrs.required !== false"
            class="required"
          > *</span>
        </slot><br>
        <span
          class="hint d-block"
        >
          <slot
            name="hint"
          >
            {{ $attrs.hint }}
          </slot>
        </span>
      </b-form-checkbox>
    </div>
  </ValidationProvider>
</template>

<script>
import basicComponentMixin from './basic-component-mixin.js'
export default {
  name: 'BasicCheckbox',
  mixins: [basicComponentMixin],
  props: {
    size: {
      type: String,
      default: ''
    }
  },
  computed: {
    checkboxRules () {
      const validation = { ...this.getValidation }
      if (validation.required) validation.required = { allowFalse: false }
      return validation
    }
  }
}
</script>

<style lang="scss" scoped>
  span.required {
    color: #9e0000;
  }
</style>
